import axios from 'axios';
import { ForbiddenErrorErrorEnum, ForbiddenErrorStatusEnum, UnauthorizedErrorStatusEnum } from '@cdaas/api-clients/dist/asset-user-openapi';

import store from './../store/configureStore';
import history from './../history';
import { executeLogout, bankIdNotVerified, phoneNumberNotVerified } from '../store/actions';
import { AuthActions } from '../types';

const LanguageCodes = { en: 'en-GB', no: 'no-NO' };

const instance = axios.create({
  baseURL: process.env.REACT_APP_BFF_URI,
  withCredentials: true,
  headers: {
    common: {
      'Accept-Language': 'en-GB',
    },
  },
});

let unauthenticationInterceptor: number;

export const setHeaderLanguage = (language: string): void => {
  if (language === 'en' || language === 'no') {
    instance.defaults.headers.common['Accept-Language'] = LanguageCodes[language];
  }
};

export const setAuthenticationHeader = (token: string): void => {
  instance.defaults.headers.common.Authorization = `Bearer ${token}`;
};

export const resetAuthenticationHeader = (): void => {
  delete instance.defaults.headers.common.Authorization;
};

export const setUnauthenticationInterceptor = () => {
  unauthenticationInterceptor = instance.interceptors.response.use(
    response => response,
    error => {
      const { dispatch } = store;
      if (error.response.status === UnauthorizedErrorStatusEnum.NUMBER_401) {
        dispatch(executeLogout() as unknown as AuthActions);
        history.push('/authentication/logout');
      } else if (
        error.response.status === ForbiddenErrorStatusEnum.NUMBER_403 &&
        error?.response?.data?.error === ForbiddenErrorErrorEnum.IdentityNotVerified
      ) {
        dispatch(bankIdNotVerified());
      } else if (
        error.response.status === ForbiddenErrorStatusEnum.NUMBER_403 &&
        error?.response?.data?.error === ForbiddenErrorErrorEnum.PhoneNumberNotVerified
      ) {
        // In practice this scenario should not happen, because this error usually comes from /me endpoint.
        // From there phone number gets verified and saved to PIM.
        // This interceptor is set only after request to endpoint /me is successful.
        // If for some reason we get this error in some other endpoint than /me then lets handle error properly.
        dispatch(phoneNumberNotVerified(error.response.data.phone_number, ''));
      } else if (error.response.status === ForbiddenErrorStatusEnum.NUMBER_403) {
        history.push('/authentication/access-denied');
      } else {
        return Promise.reject(error);
      }
    },
  );
};

export const resetUnauthenticationInterceptor = () => {
  instance.interceptors.response.eject(unauthenticationInterceptor);
};

export default instance;
